import { IGetPublishTermsResponseData, ITermSchema } from '../internalTypes';
import { getServiceId } from './getServiceId';

export function getCalltrackingTerm(data: IGetPublishTermsResponseData): ITermSchema | null {
  const { terms } = data;

  if (!terms) {
    return null;
  }

  const calltrackingTerm = terms.find(term => getServiceId(term) === 'calltracking');

  return calltrackingTerm || null;
}
